
import { post,get } from "../../axios/index"
export const getArticleAnalysis = (p) => post("/api/ai/article_analysis", p)
export const chatPage = (p) => get("/chat/chatSessionPage", p)
export const recordChatPage = (p) => get("/chat/sessionRecordPage", p)
export const deleteChat = (p) => get("/chat/deleteChatSession", p)
export const toChatPage = (p) => post("/chat/chat", p)